// extracted by mini-css-extract-plugin
export var autoSuggestion = "styles-module--autoSuggestion--67492";
export var backdrop = "styles-module--backdrop--b28a2";
export var closeBtn = "styles-module--closeBtn--1d5c6";
export var closeIcon = "styles-module--closeIcon--88724";
export var isActive = "styles-module--isActive--e0774";
export var search = "styles-module--search--832f6";
export var searchBtn = "styles-module--searchBtn--ce453";
export var searchField = "styles-module--searchField--76f06";
export var searchIcon = "styles-module--searchIcon--c3fd6";
export var searchInput = "styles-module--searchInput--46597";
export var small = "styles-module--small--4b64d";